import { createAction } from 'redux-actions';

import { FULLSCREEN_ENTER, FULLSCREEN_EXIT } from './constants';

export const fullscreenEnter = createAction(FULLSCREEN_ENTER);
export const fullscreenExit = createAction(FULLSCREEN_EXIT);
